import {alias, createModelSchema, identifier, reference,} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class SearchKind extends Cloneable {
    static NONE = new SearchKind(0, "NONE");
    static ITEM = new SearchKind(1, "ITEM");
    static SHOP = new SearchKind(2, "SHOP");
    static CELL = new SearchKind(3, "CELL");
    static MAGNET = new SearchKind(4, "MAGNET");
    static DYNAMIT = new SearchKind(5, "DYNAMIT");


    static _values = [
        this.NONE,
        this.ITEM,
        this.CELL,
        this.SHOP,
        this.MAGNET,
        this.DYNAMIT
    ];

    static getValues() {
        return SearchKind._values;
    }

    static getValue(id) {
        let value = SearchKind._values.find(v => v.id === id) || null;
        console.assert(value, "unknown model: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, SearchKind.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof SearchKind) {
            return SearchKind._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof SearchKind) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SearchKind());
        } else if (target instanceof SearchKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SearchKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});